const getAuthToken = () => {
  let postager_auth = localStorage.getItem('postager_auth');
  postager_auth = JSON.parse(postager_auth);
  if (postager_auth?.token?.length > 0) {
    return postager_auth.token;
  } else {
    return '';
  }
};

const config = {
  headers: {
    Authorization: `Bearer ${getAuthToken()}`,
  },
};

export { getAuthToken, config };
